// src/Theme/them.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light', // or 'dark'
        primary: {
            main: '#4ea27d', // your primary color
        },
        secondary: {
            main: '#979797', // your secondary color
        },
    },
    typography: {
        fontFamily: `'Poppins', sans-serif`,
    },
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: `'Poppins', sans-serif`,
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    fontFamily: `'Poppins', sans-serif`,
                },
            },
        },
    },
});

export default theme;